module.exports = __webpack_public_path__ + "static/media/p1.2b5d80e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/p1.png
// module id = 262
// module chunks = 0